<template>
  <path
    d="M12 20.0002C13.1 20.0002 14 19.1002 14 18.0002V6.00018C14 4.90018 13.1 4.00018 12 4.00018C10.9 4.00018 10 4.90018 10 6.00018V18.0002C10 19.1002 10.9 20.0002 12 20.0002ZM6 20.0002C7.1 20.0002 8 19.1002 8 18.0002V14.0002C8 12.9002 7.1 12.0002 6 12.0002C4.9 12.0002 4 12.9002 4 14.0002V18.0002C4 19.1002 4.9 20.0002 6 20.0002ZM16 11.0002V18.0002C16 19.1002 16.9 20.0002 18 20.0002C19.1 20.0002 20 19.1002 20 18.0002V11.0002C20 9.90018 19.1 9.00018 18 9.00018C16.9 9.00018 16 9.90018 16 11.0002Z"
  />
</template>
